import { Badge } from "./ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface TooltipBadgeProps {
  children: React.ReactNode;
  tooltip: string;
  variant?: "default" | "secondary" | "outline" | "destructive";
  style?: React.CSSProperties;
  className?: string;
}

export function TooltipBadge({
  children,
  tooltip,
  variant = "default",
  style = {},
  className = "",
}: TooltipBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge 
          variant={variant} 
          style={style} 
          className={`cursor-help transition-smooth hover:opacity-90 ${className}`}
        >
          {children}
        </Badge>
      </TooltipTrigger>
      <TooltipContent 
        side="top"
        style={{
          backgroundColor: 'var(--popover)',
          color: 'var(--popover-foreground)',
          border: '1px solid var(--border)',
          boxShadow: 'var(--elevation-md)',
        }}
      >
        <p style={{ fontSize: 'var(--text-sm)' }}>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
}
